import { render, staticRenderFns } from "./dataKanban.vue?vue&type=template&id=b326c038&scoped=true&"
import script from "./dataKanban.vue?vue&type=script&lang=js&"
export * from "./dataKanban.vue?vue&type=script&lang=js&"
import style0 from "./dataKanban.vue?vue&type=style&index=0&id=b326c038&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b326c038",
  null
  
)

export default component.exports